// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"b606cca7","815":"b606cca7","944":"b606cca7"}[chunkId] + ".chunk.css";
};